import Lightbox, { Slide } from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./CustomLightbox.css";  // para no ocultar la imagen mientras se carga

interface CustomLightboxProps {
	open: boolean;
	close: () => void;
	slides: Slide[];
}

export default function CustomLightbox({ open, close, slides }: CustomLightboxProps) {
	return <Lightbox
		open={open}
		close={close}
		slides={slides}
		plugins={[Captions, Counter, Fullscreen, Thumbnails, Zoom]}
		zoom={{
			scrollToZoom: true,
		}}
	/>
}
